import { SET_HIGHLIGHTED_BOOKING_IDS, SET_SELECTED_BLOCKED_TIME } from './actionTypes'
import { CalendarEventEventTypeEnum, ListCalendarEventsViewTypeEnum } from '@trybeapp/sdk'

/**
 * @deprecated
 * @see ListCalendarEventsViewTypeEnum.Practitioner
 */
export const VIEW_TYPE_PRACTITIONER = ListCalendarEventsViewTypeEnum.Practitioner
/**
 * @deprecated
 * @see ListCalendarEventsViewTypeEnum.Room
 */
export const VIEW_TYPE_ROOM = ListCalendarEventsViewTypeEnum.Room
/**
 * @deprecated
 * @see ListCalendarEventsViewTypeEnum.Area
 */
export const VIEW_TYPE_AREA = ListCalendarEventsViewTypeEnum.Area
/**
 * @deprecated
 * @see CalendarEventEventTypeEnum.Appointment
 */
export const EVENT_TYPE_APPOINTMENT = CalendarEventEventTypeEnum.Appointment
/**
 * @deprecated
 * @see CalendarEventEventTypeEnum.Session
 */
export const EVENT_TYPE_SESSION = CalendarEventEventTypeEnum.Session
/**
 * @deprecated
 * @see CalendarEventEventTypeEnum.BlockedTime
 */
export const EVENT_TYPE_BLOCKED_TIME = CalendarEventEventTypeEnum.BlockedTime
/**
 * @deprecated
 * @see CalendarEventEventTypeEnum.AreaBooking
 */
export const EVENT_TYPE_AREA_BOOKING = CalendarEventEventTypeEnum.AreaBooking

export const INITIAL_STATE = {
  highlightedBookingIds: [],
  selectedBlockedTime: null,
}

const reducer = (state = { ...INITIAL_STATE }, action) => {
  switch (action.type) {
    case SET_HIGHLIGHTED_BOOKING_IDS:
      return {
        ...state,
        highlightedBookingIds: action.highlightedBookingIds ?? [],
      }

    case SET_SELECTED_BLOCKED_TIME:
      return {
        ...state,
        selectedBlockedTime: action.blockedTime,
      }
    default:
      return state
  }
}

export default reducer
